import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2c9818aa"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["poster", "onClick"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "play-button-overlay"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/oukTlR_OqJBj7/69a7ec84e4b026fef9ff2f13.png",
  alt: "play",
  class: "play-button"
}, null, -1));

const _hoisted_5 = [_hoisted_4];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-gradient"
}, null, -1));

const _hoisted_7 = {
  class: "video-title"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/UugXaA_vlgkiI/69a7f0ece4b0eb566cf8cd66.png",
  alt: "close"
}, null, -1));

const _hoisted_9 = [_hoisted_8];
import { ref, watch } from 'vue';
export default {
  props: {
    show: Boolean,
    videoInfo: Object
  },
  emits: ['update:show'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const videoRef = ref(null);
    const isPlaying = ref(false);

    const close = () => {
      emit('update:show', false);
    };

    const togglePlay = () => {
      if (videoRef.value) {
        if (videoRef.value.paused) {
          videoRef.value.play();
        } else {
          videoRef.value.pause();
        }
      }
    };

    watch(() => props.show, newVal => {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';

        if (videoRef.value) {
          videoRef.value.pause();
          isPlaying.value = false;
        }
      }
    });
    return (_ctx, _cache) => {
      return __props.show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "video-play-overlay",
        onClick: close
      }, [_createElementVNode("div", {
        class: "video-modal",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [_createElementVNode("div", {
        class: "video-container",
        onClick: togglePlay
      }, [_createElementVNode("video", {
        ref_key: "videoRef",
        ref: videoRef,
        class: "video-player",
        poster: __props.videoInfo.cover,
        onClick: _withModifiers(togglePlay, ["stop"]),
        onPlay: _cache[0] || (_cache[0] = $event => isPlaying.value = true),
        onPause: _cache[1] || (_cache[1] = $event => isPlaying.value = false)
      }, [_createElementVNode("source", {
        src: __props.videoInfo.url,
        type: "video/mp4"
      }, null, 8, _hoisted_2)], 40, _hoisted_1), _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [[_vShow, !isPlaying.value]]), _hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(__props.videoInfo.title), 1)]), _createElementVNode("button", {
        class: "close-btn",
        onClick: close
      }, _hoisted_9)])])) : _createCommentVNode("", true);
    };
  }

};